import PersonalDetails from './personal-details.jsx';

export default PersonalDetails;
